import { CsvColumns } from './import-export-service-types';

export const stopValidKeys: string[] = [CsvColumns.STOP_NAME];

export const configValidKeys: string[] = [CsvColumns.CONFIG_UNITS];

export const defaultValidKeys: string[] = [
  CsvColumns.SPACE_NAME,
  CsvColumns.LENGTH,
  CsvColumns.WIDTH,
  CsvColumns.HEIGHT,
  CsvColumns.LOADING_TYPE,
  // CsvColumns.IS_SET,
];

export const palletValidKeys: string[] = [
  CsvColumns.SPACE_NAME,
  CsvColumns.LENGTH,
  CsvColumns.WIDTH,
  CsvColumns.PALLET_MAX_HEIGHT,
  CsvColumns.LOADING_TYPE,
  CsvColumns.PALLET_WEIGHT,
  CsvColumns.PALLET_HEIGHT,
];

export const airContainerValidKeys: string[] = [
  CsvColumns.SPACE_NAME,
  CsvColumns.AIR_BASE_B,
  CsvColumns.AIR_HEIGHT_C,
  CsvColumns.AIR_HEIGHT_D,
  CsvColumns.AIR_LENGTH_A,
  CsvColumns.AIR_TYPE,
  CsvColumns.AIR_WIDTH,
  CsvColumns.LOADING_TYPE,
  CsvColumns.LIMIT,
];

export const validKeysBox: string[] = [
  CsvColumns.LOAD_NAME,
  CsvColumns.LENGTH,
  CsvColumns.WIDTH,
  CsvColumns.HEIGHT,
  CsvColumns.WEIGHT,
  CsvColumns.LOAD_TYPE,
  CsvColumns.QUANTITY,
];

export const validKeysBarrel: string[] = [
  CsvColumns.LOAD_NAME,
  CsvColumns.HEIGHT,
  CsvColumns.DIAMETER,
  CsvColumns.LOAD_TYPE,
  CsvColumns.QUANTITY,
];

export const validKeysPipe: string[] = [
  CsvColumns.LOAD_NAME,
  CsvColumns.LENGTH,
  CsvColumns.DIAMETER,
  CsvColumns.LOAD_TYPE,
  CsvColumns.QUANTITY,
];

export const trueFalseColumns: string[] = [
  // CsvColumns.IS_SET,
  CsvColumns.STACKING,
  CsvColumns.ALONG_FLOOR,
  CsvColumns.ROTATE_ON_BASE,
  CsvColumns.ROTATE_FREELY,
];

export const stringColumns: string[] = [
  CsvColumns.CONFIG_UNITS,
  CsvColumns.STOP_NAME,
  CsvColumns.SPACE_NAME,
  CsvColumns.LOAD_NAME,
  CsvColumns.CITY,
  CsvColumns.POSTAL_CODE,
  CsvColumns.COUNTRY,
];

export const numberColumns: string[] = [
  CsvColumns.LENGTH,
  CsvColumns.WIDTH,
  CsvColumns.HEIGHT,
  CsvColumns.LIMIT,
  CsvColumns.DIAMETER,
  CsvColumns.WEIGHT,
  CsvColumns.QUANTITY,
  CsvColumns.MAX_LOADS_ON_TOP,
  CsvColumns.MAX_WEIGHT_ON_TOP,
  CsvColumns.PCT_SUPPORT,
  CsvColumns.CENTER_OF_MASS_X,
  CsvColumns.CENTER_OF_MASS_Y,
  CsvColumns.CENTER_OF_MASS_Z,
  CsvColumns.COOLER_WIDTH,
  CsvColumns.COOLER_HEIGHT,
  CsvColumns.COOLER_LENGTH,
  CsvColumns.COOLER_FLOOR_HEIGHT,
  CsvColumns.WHEEL_WIDTH,
  CsvColumns.WHEEL_HEIGHT,
  CsvColumns.WHEEL_LENGTH,
  CsvColumns.WHEEL_DISTANCE,
  CsvColumns.VARIO_FLOOR_HEIGHT,
  CsvColumns.VARIO_FLOOR_THICKNESS,
  CsvColumns.VARIO_FLOOR_CAPACITY,
  CsvColumns.AIR_BASE_B,
  CsvColumns.AIR_HEIGHT_C,
  CsvColumns.AIR_HEIGHT_D,
  CsvColumns.AIR_LENGTH_A,
  CsvColumns.AIR_WIDTH,
  CsvColumns.GRAVITY_LENGTH_TOLERANCE,
  CsvColumns.GRAVITY_WIDTH_TOLERANCE,
  CsvColumns.GRAVITY_CONTAINER_WEIGHT,
  CsvColumns.PALLET_WEIGHT,
  CsvColumns.PALLET_MAX_HEIGHT,
  CsvColumns.PALLET_MAX_WEIGHT,
  CsvColumns.PALLET_HEIGHT,
  CsvColumns.DOOR_HEIGHT,
  CsvColumns.DOOR_WIDTH,
];
